// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__23i9G","right":"styles_right__3xb5z"};